import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import useTranslation from 'next-translate/useTranslation';

// Hooks
import useUserRole from '@/utils/hooks/user/useUserRole';
import useAcl from '@/hooks/user/useAcl';

//Components
import LinkBase from '@/components/base/LinkBase';

const NavigationTabs = ({ children, tabs = [] }) => {
    const { t } = useTranslation();
    const { currentRole } = useUserRole();
    const { hasAcl } = useAcl();

    return (
        <div className="block w-full">
            <nav
                className="scrollbar z-0 overflow-x-auto overflow-y-hidden rounded-t border-b border-icoGray-300 bg-icoGray-100 dark:border-icoDarkMode-beton dark:bg-icoDarkMode-deepBlack"
                data-testid="navigation-tab-desktop">
                <ul className="flex w-full">
                    {children
                        ? children
                        : tabs.map((tab) => {
                              if (tab.acl) {
                                  if (tab.acl.roles) {
                                      if (!tab.acl.roles.includes(currentRole)) {
                                          return null;
                                      }
                                  }

                                  if (tab.acl.permissions) {
                                      if (!hasAcl(tab.acl.permissions)) {
                                          return null;
                                      }
                                  }
                              }

                              return (
                                  <li className="inline-flex flex-1 text-center" key={tab.label}>
                                      <NavigationTabs.Tab
                                          as={LinkBase}
                                          href={tab.value}
                                          isActive={tab.current}
                                          label={t(tab.label)}
                                      />
                                  </li>
                              );
                          })}
                </ul>
            </nav>
        </div>
    );
};

NavigationTabs.propTypes = {
    tabs: PropTypes.array,
    children: PropTypes.node
};

const Tab = ({ as: Component = 'button', children, isActive, label, ...restProps }) => {
    return (
        <Component
            className={clsx(
                'w-full rounded-lg px-5 font-GSemiBold text-sm transition duration-200 ease-in-out hover:text-icoBlack focus:z-10 focus:ring-inset',
                {
                    'bg-white text-icoBlack dark:bg-icoDarkMode-anthracite dark:text-white':
                        isActive,
                    'text-icoGray-500 dark:text-icoDarkMode-wolf': !isActive
                }
            )}
            {...restProps}>
            {children ? (
                React.Children.map(children, (child) => {
                    const newChild = React.cloneElement(child, {
                        isActive,
                        label
                    });
                    return newChild;
                })
            ) : (
                <NavigationTabs.TabItem isActive={isActive} label={label} />
            )}
        </Component>
    );
};

Tab.propTypes = {
    isActive: PropTypes.bool,
    label: PropTypes.string,
    children: PropTypes.node
};

NavigationTabs.Tab = Tab;

const TabItem = ({ isActive, label }) => (
    <p
        className={clsx('inline-block whitespace-nowrap border-2 border-transparent py-5', {
            'border-b-icoBlue': isActive
        })}>
        {label}
    </p>
);

TabItem.propTypes = {
    isActive: PropTypes.bool,
    label: PropTypes.string
};

NavigationTabs.TabItem = TabItem;

export default NavigationTabs;
